/**
 * initMenuFlyOut
 *
 * Initializes the flyout menu functionality.
 *
 * @author Co-Pilot, matt.breiwick
 */
export default function initMenuFlyOut() {
    const btn = document.getElementById('flyoutMenuBtn');
    const menu = document.getElementById('flyoutMenu');
    const closeBtn = document.getElementById('closeFlyoutMenu');

    function openMenu() {
        menu.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-expanded', 'true');
        menu.focus();

        // Add outside click listener (delay avoids immediate close)
        setTimeout(() => {
            document.addEventListener('pointerdown', handleOutsideClick, { capture: true });
        }, 0);
    }

    function closeMenu() {
        menu.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();

        // Remove outside click listener
        document.removeEventListener('pointerdown', handleOutsideClick, { capture: true });
    }

    function isModalOpen() {
        // Check for MicroModal
        const microModal = document.querySelector('.micromodal-slide.is-open');
        if (microModal) return true;

        // Check for custom lightbox
        const lightbox = document.getElementById('gf-lightbox');
        if (lightbox && !lightbox.classList.contains('is-hidden')) return true;

        // Check for any modal with aria-hidden="false"
        const anyModal = document.querySelector('[role="dialog"][aria-hidden="false"]');
        if (anyModal) return true;

        return false;
    }

    function handleOutsideClick(e) {
        // Don't close if a modal is open
        if (isModalOpen()) {
            return;
        }

        // If click is outside both the flyout and the button, close it
        if (!menu.contains(e.target) && !btn.contains(e.target)) {
            closeMenu();
        }
    }

    // Controls
    btn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    menu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            // Don't close if a modal is open (let modal handle Escape)
            if (isModalOpen()) {
                return;
            }
            closeMenu();
        }
    });
}
